export const dataHooks = {
    button: 'fill-preview-button',
};
export const SIZES = {
    extraTiny: 'extraTiny',
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
//# sourceMappingURL=FillPreview.constants.js.map